<template>
  <div class="min-vh-100 previewContainer">
    <div class="flex-container">
      <CRow class="ml-0 mr-0 mt-5 h-100">
        <CCol lg="7" sm="12" xl="7">
          <img
            v-if="data?.content?.item"
            :src="this.baseUrl + '/cpr/Image/' + data.content.item[0].data"
            class="w-100 mt-5"
          />
        </CCol>
        <CCol class="mt-md-3 pl-lg-5" lg="5" sm="12" xl="5">
          <CRow class="mt-5 w-100" v-if="data?.content?.title">
            <CCol class="text-left">
              <span class="preview-title">
                {{ $helpers.translate(data.content.title, lang) }}</span
              >
              <a
                class="float-right close-preview"
                @click="onAction(data.navigate.previous.action)"
                ><font-awesome-icon :icon="['fas', 'times']"
              /></a>
            </CCol>
          </CRow>
          <CRow class="mt-3 w-100" v-if="data?.content?.title">
            <CCol class="preview-desc">
              {{ $helpers.translate(data.content.description, lang) }}
            </CCol>
          </CRow>
          <CRow class="buttonPreview mt-md-3 mb-md-3">
            <CCol class="text-center">
              <CButton
                class="btn btn-cpr btn-secondary"
                @click="onAction(data.navigate.previous.action)"
              >
                {{ $helpers.translate(data.navigate.previous.title, lang) }}
              </CButton>
              <CButton
                class="btn btn-cpr btn-primary"
                @click="onAction(data.navigate.next.action)"
              >
                {{ $helpers.translate(data.navigate.next.title, lang) }}
              </CButton>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import PreviewComponent from '@/components/template/CPR/preview/index';
export default {
  name: 'Preview',
  components: {PreviewComponent},
  data() {
    return {
      item: [],
      courseCode: '',
      courseSection: '',
      startTime: '',
      lang: 'th',
      data: [],
      templateId: '',
      action: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
    };
  },
  computed: {
    ...mapGetters({
      // templateContent: 'template/getTemplateContent',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    // templateContent: function (val) {
    //   this.data = val;
    //   if (!val.enable) {
    //     this.$router.push({name: this.data.navigate.close.action});
    //   } else {
    //     this.templateId = val._id;
    //     this.courseSection =
    //       this.$store.getters['necessary/getLerningCourse'].groups[0].code;
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseCode,
    //       template: this.templateId,
    //       section: this.courseSection,
    //     });
    //   }
    // },
    getTemplatev3(val) {
      console.log(val, 'get preview template');
      const template = val.templates[0];
      if (!template.enable) {
        this.$router.push({name: 'v4' + template.navigate.close.action});
      }
      this.data = template;
    },
  },
  methods: {
    onAction(action) {
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.templateId,
      //   section: this.courseSection,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: [],
      // });
      //alert(action)
      // console.log(action, 'onAction');

      this.$router.push({name: 'v4' + action});
    },
  },
  mounted() {
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = this.$route.params.id;
    // this.$store.dispatch('template/fetchContent', body);
    this.$store.dispatch('v3/fetchTemplateByCode', this.$route.params.id);
  },
  created() {
    this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
    this.startTime = this.$helpers.getDateFormat();
  },
};
</script>
<style scoped>
@import '../../../assets/scss/CPR/style.scss';
.previewContainer {
  background-image: url('../../../assets/images/CPR/preview/background.jpg');
  padding: 5rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
@media screen and (min-width: 1440px) {
  .previewContainer {
    padding: 10rem 20rem;
  }
}
@media only screen and (max-width: 600px) and (min-width: 240px) {
  .previewContainer {
    background-image: url('../../../assets/images/CPR/preview/background.jpg');
    padding: 1rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
img {
  box-shadow: 10px 10px 10px #00000029;
  opacity: 1;
}
.close-preview {
  font-size: 16px;
  cursor: pointer;
}
.close-preview:hover {
  opacity: 0.8;
}
.preview-title {
  text-transform: uppercase;
  font: normal normal medium 30px/39px Roboto;
  color: #000000;
  font-weight: 500;
  text-align: left;
  font-size: 24px;
  font-family: Roboto;
  letter-spacing: 1px;
  opacity: 1;
}
.preview-desc {
  font-size: 25px;
  font-weight: 300;
}
.buttonPreview {
  bottom: 0;
  position: absolute;
  justify-content: center;
  width: 100%;
}

@media only screen and (max-width: 1200px) and (min-width: 240px) {
  .buttonPreview {
    bottom: 0;
    position: revert;
    justify-content: center;
  }
}

@media only screen and (max-width: 1600px) and (min-width: 1201px) {
  .buttonPreview {
    bottom: 0;
    position: revert;
    justify-content: center;
    left: 40%;
    padding-top: 3rem;
  }
}
</style>
